module.exports = __webpack_public_path__ + "img/s7Model4M.14c8592b.webp";